import React, { useState } from "react";
import * as XLSX from "xlsx";
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import '../../CSS/Global.css';
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { v4 as uuidv4 } from "uuid";
import Loader from "./Loader";
import { decryptToken } from "../utils/getToken";


const InvoiceImport = () => {
    const { isSidebarOpen } = useSidebar();
    const [currentStep, setCurrentStep] = useState(1);
    const [previewData, setPreviewData] = useState([]);
    const [skippedRecords, setSkippedRecords] = useState([]);
    const [validInvoices, setValidInvoices] = useState([]);
    const [failedInvoices, setFailedInvoices] = useState([]);
    const [unmappedFields, setUnmappedFields] = useState([]);
    const [uploadedFileName, setUploadedFileName] = useState("");
    const handleNext = () => currentStep < 3 && setCurrentStep(currentStep + 1);
    const handleBack = () => currentStep > 1 && setCurrentStep(currentStep - 1);
    const navigate = useNavigate();
    const url = process.env.REACT_APP_LINK
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [isImporting, setIsImporting] = useState(false);
    const token = decryptToken("accessToken") || ""


    const convertExcelDate = (serial) => {
        const baseDate = new Date(1899, 11, 30);
        const corrected = new Date(baseDate.getTime() + (serial + 1) * 86400000);
        return corrected.toISOString().split("T")[0];
    };

    const parseInvoiceDate = (rawDate) => {
        if (!rawDate) return "";

        // Excel serial date
        if (typeof rawDate === "number") {
            const baseDate = new Date(1899, 11, 30);
            const corrected = new Date(baseDate.getTime() + (rawDate + 1) * 86400000);
            return corrected.toISOString().split("T")[0];
        }

        if (typeof rawDate === "string") {
            // Check if already in YYYY-MM-DD
            const isoMatch = rawDate.match(/^\d{4}-\d{2}-\d{2}$/);
            if (isoMatch) return rawDate;

            // Handle DD/MM/YYYY or MM/DD/YYYY
            const parts = rawDate.split("/");
            if (parts.length === 3) {
                const [first, second, third] = parts;
                // Assume DD/MM/YYYY if day > 12 (avoid MM/DD confusion)
                const day = parseInt(first, 10);
                const month = parseInt(second, 10);
                const year = parseInt(third, 10);

                if (year && month && day) {
                    const paddedMonth = String(month).padStart(2, '0');
                    const paddedDay = String(day).padStart(2, '0');
                    return `${year}-${paddedMonth}-${paddedDay}`;
                }
            }

            // Try fallback to native parser
            const parsed = new Date(rawDate);
            if (!isNaN(parsed)) {
                return parsed.toISOString().split("T")[0];
            }
        }

        console.warn("Unrecognized date format:", rawDate);
        return "";
    };


    const handleFileUpload = (e) => {

        // const file = e.target.files[0];
        // if (!file) return;

        // setUploadedFileName(file.name);
        const file = e.target.files[0];
        if (!file) {
            // setUploadSuccess(false);
            return;
        }

        // ✅ Check file extension
        const allowedExtensions = ["csv", "xlsx", "xls"];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (!allowedExtensions.includes(fileExtension)) {
            toast.error("Invalid file format. Please upload a CSV, XLSX, or XLS file.", {
                position: "top-center",
                autoClose: 3000
            });
            e.target.value = ""; // Clear input
            return;
        }

        setUploadedFileName(file.name); // ✅ Update state after successful check

        const reader = new FileReader();

        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: "binary" });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws);

            const parsed = [];
            const reasonSet = new Set();
            const requiredFields = [
                "invoice_date",

            ];

            // data.forEach((row, index) => {
            //     let hasMissing = false;

            //     requiredFields.forEach((field) => {
            //         if (!(field in row) || row[field] === "") {
            //             reasonSet.add(`Row ${index + 2}: Missing or empty "${field}"`);
            //             hasMissing = true;
            //         }
            //     });

            //     const normalizeArray = (value) => {
            //         if (typeof value === "number") return [String(value)];
            //         if (typeof value === "string") return value.split(",").map(v => v.trim() || "0");
            //         return [];
            //     };

            //     const itemsArray = normalizeArray(row.Items || "");
            //     const quantityArray = normalizeArray(row.Quantity || "");
            //     const rateArray = normalizeArray(row.Rate || "");
            //     const discountArray = normalizeArray(row.Discount || "");
            //     const taxArray = normalizeArray(row.Tax || "");



            //     const validateNumberFields = (rowIndex, column, values) => {
            //         const errors = [];
            //         values.forEach((val, i) => {
            //             if (isNaN(Number(val.trim()))) {
            //                 errors.push(`Row ${rowIndex + 2}: Field "${column}", Value "${val}" is not a number`);
            //             }
            //         });
            //         return errors;
            //     };

            //     // const taxArray = toArray(row.Tax || "");


            //     const qErrors = validateNumberFields(index, "Quantity", quantityArray);
            //     const rErrors = validateNumberFields(index, "Rate", rateArray);
            //     const dErrors = validateNumberFields(index, "Discount", discountArray);
            //     const tErrors = validateNumberFields(index, "Tax", taxArray);
            //     const fieldTypeErrors = [...qErrors, ...rErrors, ...dErrors, ...tErrors];
            //     fieldTypeErrors.forEach(err => reasonSet.add(err));

            //     const combinedItems = itemsArray.map((item, index) => ({
            //         item: item.trim(),
            //         quantity: quantityArray[index]?.trim() || "0",
            //         rate: rateArray[index]?.trim() || "0",
            //         discount: discountArray[index]?.trim() || "0",
            //         tax: taxArray[index]?.trim() || "0"
            //     }));

            //     if (
            //         itemsArray.length !== quantityArray.length ||
            //         itemsArray.length !== rateArray.length ||
            //         itemsArray.length !== discountArray.length ||
            //         itemsArray.length !== taxArray.length
            //     ) {
            //         // ❗ Skip silently without adding to skipped list
            //         return;
            //     }


            //     parsed.push({
            //         invoice_date: typeof row.invoice_date === "number" ? convertExcelDate(row.invoice_date) : row.invoice_date,
            //         customer_id: row["Customer ID"] || "",
            //         sales_person_id: row["Sales Person ID"] || "",
            //         sales_person_name: row["Sales Person Name"] || "",
            //         customer_name: row.customer_name,
            //         due_date: typeof row.due_date === "number" ? convertExcelDate(row.due_date) : row.due_date,
            //         items: JSON.stringify(combinedItems),
            //         advance_payment: parseFloat(row["Advance Payment"] || 0),
            //         shipping: parseFloat(row["Service Fees/Shipping"] || 0),
            //         customer_note: row["Customer Note"] || "",

            //     });



            // });

            data.forEach((row, index) => {
                let hasMissing = false;

                requiredFields.forEach((field) => {
                    if (!(field in row) || row[field] === "") {
                        reasonSet.add(`Row ${index + 2}: Missing or empty "${field}"`);
                        hasMissing = true;
                    }
                });

                const normalizeArray = (value, expectedLength = 1) => {
                    let arr = [];
                    if (typeof value === "number") arr = [String(value)];
                    else if (typeof value === "string") arr = value.split(",").map(v => v.trim() || "0");
                    else arr = [];

                    // pad to expected length
                    while (arr.length < expectedLength) arr.push("0");
                    return arr;
                };

                const parseInvoiceDate = (rawDate) => {
                    if (!rawDate) return "";

                    // ✅ Case 1: Excel serial number
                    if (typeof rawDate === "number") {
                        const baseDate = new Date(1899, 11, 30);
                        const corrected = new Date(baseDate.getTime() + (rawDate + 1) * 86400000);
                        return corrected.toISOString().split("T")[0];
                    }

                    // ✅ Case 2: Already a valid Date object
                    if (Object.prototype.toString.call(rawDate) === "[object Date]" && !isNaN(rawDate)) {
                        return rawDate.toISOString().split("T")[0];
                    }

                    // ✅ Case 3: String formats
                    if (typeof rawDate === "string") {
                        // If already ISO format
                        if (/^\d{4}-\d{2}-\d{2}$/.test(rawDate)) return rawDate;

                        // Handle DD/MM/YYYY or MM/DD/YYYY
                        if (rawDate.includes("/")) {
                            const parts = rawDate.split("/").map(Number);
                            if (parts.length === 3) {
                                const [a, b, c] = parts;
                                const isDMY = a > 12;
                                const day = isDMY ? a : b;
                                const month = isDMY ? b : a;
                                const year = c;
                                if (year && month && day) {
                                    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                                }
                            }
                        }

                        // Handle DD-MM-YYYY or MM-DD-YYYY
                        if (rawDate.includes("-")) {
                            const parts = rawDate.split("-").map(Number);
                            if (parts.length === 3) {
                                const [a, b, c] = parts;
                                const isDMY = a > 12;
                                const day = isDMY ? a : b;
                                const month = isDMY ? b : a;
                                const year = c;
                                if (year && month && day) {
                                    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                                }
                            }
                        }

                        // Fallback: try native parser
                        const parsed = new Date(rawDate);
                        if (!isNaN(parsed)) {
                            return parsed.toISOString().split("T")[0];
                        }
                    }

                    // Fallback if nothing matches
                    console.warn("Unrecognized date format:", rawDate);
                    return "";
                };



                const itemsArray = normalizeArray(row.Items || "");
                const quantityArray = normalizeArray(row.Quantity || "", itemsArray.length);
                const rateArray = normalizeArray(row.Rate || "", itemsArray.length);
                const discountArray = normalizeArray(row.Discount || "", itemsArray.length);
                const taxArray = normalizeArray(row.Tax || "", itemsArray.length);


                // ✅ Skip mismatched rows entirely
                if (
                    itemsArray.length !== quantityArray.length ||
                    itemsArray.length !== rateArray.length ||
                    itemsArray.length !== discountArray.length ||
                    itemsArray.length !== taxArray.length
                ) {
                    return; // silently skip mismatched rows
                }

                // ✅ Only validate numbers AFTER ensuring arrays are equal
                const validateNumberFields = (rowIndex, column, values) => {
                    const errors = [];
                    values.forEach((val) => {
                        if (isNaN(Number(val.trim()))) {
                            errors.push(`Row ${rowIndex + 2}: Field "${column}", Value "${val}" is not a number`);
                        }
                    });
                    return errors;
                };

                const qErrors = validateNumberFields(index, "Quantity", quantityArray);
                const rErrors = validateNumberFields(index, "Rate", rateArray);
                const dErrors = validateNumberFields(index, "Discount", discountArray);
                const tErrors = validateNumberFields(index, "Tax", taxArray);
                const fieldTypeErrors = [...qErrors, ...rErrors, ...dErrors, ...tErrors];
                fieldTypeErrors.forEach(err => reasonSet.add(err)); // only keep real type errors

                const idArray = normalizeArray(row["Item IDs"] || "", itemsArray.length);

                const combinedItems = itemsArray.map((item, index) => ({
                    id: uuidv4(),            // ✅ Include item ID
                    item: { title: item.trim() },
                    quantity: quantityArray[index]?.trim() || "0",
                    rate: rateArray[index]?.trim() || "0",
                    discount: discountArray[index]?.trim() || "0",
                    tax: taxArray[index]?.trim() || "0"
                }));


                parsed.push({
                    invoice_date: parseInvoiceDate(row.invoice_date),
                    due_date: parseInvoiceDate(row.due_date),
                    // invoice_date: typeof row.invoice_date === "number" ? convertExcelDate(row.invoice_date) : row.invoice_date,
                    customer_id: row["Customer ID"] || "",
                    sales_person_id: row["Sales Person ID"] || "",
                    sales_person_name: row["Sales Person Name"] || "",
                    customer_name: row.customer_name,
                    // due_date: typeof row.due_date === "number" ? convertExcelDate(row.due_date) : row.due_date,
                    items: JSON.stringify(combinedItems),
                    advance_payment: parseFloat(row["Advance Payment"] || 0),
                    shipping: parseFloat(row["Service Fees/Shipping"] || 0),
                    customer_note: row["Customer Note"] || "",
                });
            });

            setPreviewData(parsed);

            const valid = parsed.filter((_, i) => {
                const original = data[i];
                return requiredFields.every(f => f in original && original[f]);
            });

            setValidInvoices(valid);
            setSkippedRecords([...reasonSet]);

            const unmappedOnly = Array.from(reasonSet).filter(reason =>
                reason.includes("is not a number")
            );
            setUnmappedFields(unmappedOnly);

            const skippedOnly = Array.from(reasonSet).filter(reason =>
                !reason.includes("is not a number")
            );
            setSkippedRecords(skippedOnly);

        };

        reader.readAsBinaryString(file);
    };

    const handleImport = async () => {
        if (skippedRecords.length > 0 || unmappedFields.length > 0) {
            alert("Some records were skipped or contain unmapped fields. Bulk data is not imported.");
            return;
        }
        setIsImporting(true);
        try {
            const response = await fetch(`${url}/newinvoice/import-bulk`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    invoices: validInvoices,
                    user_id: isLoggedIn?.main_id,
                    user_name: isLoggedIn?.full_name
                }),
            });

            const result = await response.json();

            if (response.ok) {
                // alert(result.message || "Import completed!");
                toast.success("Invoices imported successfully!", {
                    position: "top-center",
                    autoClose: 2000,
                });
                navigate("/invoice");

                setFailedInvoices(result.failed || []);
            } else {
                toast.error("Import failed: " + result.message, {
                    position: "top-center",
                    autoClose: 2000,
                });
                // alert("Import failed: " + result.message);
                console.error("Validation Error:", result.error);
            }
        } catch (error) {
            toast.error("An error occurred while importing.", {
                position: "top-center",
                autoClose: 2000,
            });
            console.error("Import error:", error);
            // alert("An error occurred while importing.");
        } finally {
            setIsImporting(false); // Stop loading in both cases
        }
    };



    return (
        <>

            {isImporting && <Loader />}
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <h2 className="customer-import">Invoice - select file</h2>

                <div className="import-step">
                    {[1, 2, 3].map(step => (
                        <div
                            key={step}
                            className={`import-step__item ${currentStep > step ? "past" : currentStep === step ? "active" : "upcoming"}`}
                        >
                            {step}
                        </div>
                    ))}
                </div>

                {currentStep === 1 && (
                    <div className="customer-import-card">
                        <div className="import-icon">
                            <i className="fa-solid fa-file-arrow-down"></i>
                        </div>
                        <p className="scan-drop">Drag and drop file to import</p>
                        <div className="upload-file">
                            <label htmlFor="file" className="upload-border">
                                <i className="fa-solid fa-file-arrow-down"></i> Import file
                                <input type="file" id="file" name="file" className="file-input" onChange={handleFileUpload} />
                            </label>
                        </div>

                        {uploadedFileName && (
                            <p style={{ marginTop: "10px", color: "green", fontWeight: "bold" }}>
                                "{uploadedFileName}" is imported successfully!
                            </p>
                        )}

                        <p className="file-type">
                            Maximum File Size: 25 MB • File Format: CSV, TSV, or XLS
                        </p>
                    </div>
                )}


                {currentStep === 2 && (
                    <div className="customer-import-card">
                        <h4>Preview Imported Data</h4>
                        <div className="preview-table-wrapper">
                            <table className="preview-table">
                                <thead>
                                    <tr>
                                        <th>Invoice Date</th>
                                        <th>Customer Name</th>
                                        <th>Due Date</th>
                                        <th>Items</th>
                                        <th>Quantity</th>
                                        <th>Rate</th>
                                        <th>Discount</th>
                                        <th>Tax</th>
                                        <th>Advance Payment</th>
                                        <th>Shipping</th>
                                        <th>Customer Note</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {previewData.map((row, i) => {
                                        const items = JSON.parse(row.items || "[]");
                                        return items.map((item, itemIndex) => (
                                            <tr key={`${i}-${itemIndex}`}>
                                                <td style={{ textAlign: "center" }}>{itemIndex === 0 ? row.invoice_date : ""}</td>
                                                <td style={{ textAlign: "center" }}>{itemIndex === 0 ? row.customer_name : ""}</td>
                                                <td style={{ textAlign: "center" }}>{itemIndex === 0 ? row.due_date : ""}</td>
                                                <td style={{ textAlign: "center" }}>
                                                    {typeof item.item === "object" ? item.item.title : item.item}
                                                </td>

                                                <td style={{ textAlign: "center" }}>{item.quantity}</td>
                                                <td style={{ textAlign: "center" }}>{item.rate}</td>
                                                <td style={{ textAlign: "center" }}>{item.discount}</td>
                                                <td style={{ textAlign: "center" }}>{item.tax}</td>
                                                <td style={{ textAlign: "center" }}>{itemIndex === 0 ? row.advance_payment : ""}</td>
                                                <td style={{ textAlign: "center" }}>{itemIndex === 0 ? row.shipping : ""}</td>
                                                <td style={{ textAlign: "center" }}>{itemIndex === 0 ? row.customer_note : ""}</td>
                                            </tr>
                                        ));

                                    })}
                                </tbody>

                            </table>
                        </div>
                    </div>
                )}

                {currentStep === 3 && (
                    <div className="customer-import-card">
                        <p className="import-success">
                            Invoices ready to import: {validInvoices.length}
                        </p>
                        <p className="import-error">
                            Records skipped: {skippedRecords.length}
                        </p>
                        <p className="import-error">Unmapped Fields: {unmappedFields.length}</p>
                        {unmappedFields.length > 0 && (
                            <div className="skipped-records">
                                <h4>Field Type Issues (Unmapped Fields):</h4>
                                <ul>
                                    {unmappedFields.map((err, i) => (
                                        <li key={i}>{err}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {skippedRecords.length > 0 && (
                            <div className="skipped-records">
                                <h4>Skipped Columns:</h4>
                                <ul>
                                    {skippedRecords.map((reason, i) => (
                                        <li key={i}>{reason}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {failedInvoices.length > 0 && (
                            <div className="skipped-records">
                                <h4>Failed Invoices (From Server Validation):</h4>
                                <table className="preview-table">
                                    <thead>
                                        <tr>
                                            <th>Order #</th>
                                            <th>Customer</th>
                                            <th>Reason</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {failedInvoices.map((fail, i) => (
                                            <tr key={i}>
                                                <td>{fail.invoice?.order_number}</td>
                                                <td>{fail.invoice?.customer_name}</td>
                                                <td>{fail.reason}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                )}

                <div className="import-buttons">
                    {currentStep > 1 && (
                        <button className="import-back" onClick={handleBack}>Back</button>
                    )}
                    {currentStep === 3 && (
                        <button className="import-button" onClick={handleImport}>Import</button>
                    )}
                    {currentStep < 3 && (
                        <button className="import-next" onClick={handleNext}>Next</button>
                    )}
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default InvoiceImport;
